import React from "react";
import Header from "./Header";
import GrowBusiness from "./GrowBusiness";
import GetExtra from "./GetExtra";
import MarketingCampaigns from "./MarketingCampaigns";
import GetStarted from "./GetStarted";
import ReachMarkets from "./ReachMarkets";
import WhyItWorks from "./WhyItWorks";
import SecondForm from "./SecondForm";
import FAQ from "./FAQ";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";
import { ES_HOME_PATH, ES_CLIENTS_PATH, ES_PROMOTE_PATH } from "../routes";
import { Link } from "react-router-dom";

const HomePageSpanish = () => {
  const handleSampleDownloadClick = () => {
    if (typeof window === "undefined") return;

    // Track in GTM-style dataLayer if available
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "sample_file_download_click",
        location: "grow_business",
        language: "es",
      });
    }

    // Track in GA-style gtag if available
    if (typeof window.gtag === "function") {
      window.gtag("event", "sample_file_download_click", {
        event_category: "engagement",
        event_label: "grow_business_es",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Cómo conseguir clientes para tu negocio de limpieza comercial</title>
        <meta
          name="description"
          content="Aprende cómo las empresas de limpieza comercial consiguen clientes de forma constante con un proceso probado paso a paso y leads de limpieza comercial dirigidos."
        />
        <link rel="canonical" href={`https://www.commercialcleaningleadsforyou.com${ES_HOME_PATH}`} />
        <link rel="alternate" hrefLang="en" href="https://www.commercialcleaningleadsforyou.com/" />
        <link rel="alternate" hrefLang="es" href={`https://www.commercialcleaningleadsforyou.com${ES_HOME_PATH}`} />
        <link rel="alternate" hrefLang="x-default" href="https://www.commercialcleaningleadsforyou.com/" />
        <meta name="language" content="Spanish" />
      </Helmet>
      <Header />
      <GrowBusiness lang="es" onSampleDownloadClick={handleSampleDownloadClick} />
      <GetExtra lang="es" />
      <MarketingCampaigns lang="es" />
      <GetStarted lang="es" />
      <ReachMarkets lang="es" />
      <WhyItWorks lang="es" />
      <SecondForm lang="es" />
      <FAQ lang="es" />
      <div className="bg-[#e8f4f6] py-6 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-[#1465B7] font-semibold text-sm uppercase tracking-wide mb-3 text-center">
            Guías relacionadas
          </p>
          <p className="related-guides-links flex flex-wrap justify-center gap-x-4 gap-y-2 items-center text-center">
            <Link to={ES_CLIENTS_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">
              Cómo conseguir clientes para tu negocio de limpieza comercial
            </Link>
            <Link to={ES_PROMOTE_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">
              Cómo promocionar tu negocio de limpieza comercial
            </Link>
          </p>
        </div>
      </div>
      <Footer lang="es" />
    </>
  );
};

export default HomePageSpanish;
